module.exports = __webpack_public_path__ + "img/productManualDetailsBj.1dd0ec04.png";